import { render, staticRenderFns } from "./KasBesar.vue?vue&type=template&id=21a03938"
import script from "./KasBesar.vue?vue&type=script&lang=js"
export * from "./KasBesar.vue?vue&type=script&lang=js"
import style0 from "./KasBesar.vue?vue&type=style&index=0&id=21a03938&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports